// node_modules/ftdomdelegate/main.js
function Delegate(root) {
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }
  this.handle = Delegate.prototype.handle.bind(this);
  this._removedListeners = [];
}
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }
  this.rootElement = root;
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, true);
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, false);
    }
  }
  return this;
};
Delegate.prototype.captureForType = function (eventType) {
  return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(eventType) !== -1;
};
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;
  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }
  if (useCapture === void 0) {
    useCapture = this.captureForType(eventType);
  }
  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }
  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, useCapture);
    }
    listenerMap[eventType] = [];
  }
  if (!selector) {
    matcherParam = null;
    matcher = matchesRoot.bind(this);
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }
  listenerMap[eventType].push({
    selector,
    handler,
    matcher,
    matcherParam
  });
  return this;
};
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }
  if (useCapture === void 0) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }
    return this;
  }
  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];
    if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }
  if (!listenerList.length) {
    delete listenerMap[eventType];
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }
  return this;
};
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";
  if (event[eventIgnore] === true) {
    return;
  }
  target = event.target;
  if (target.nodeType === 3) {
    target = target.parentNode;
  }
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }
  root = this.rootElement;
  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
  switch (phase) {
    case 1:
      listenerList = this.listenerMap[1][type];
      break;
    case 2:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3:
      listenerList = this.listenerMap[0][type];
      break;
  }
  let toFire = [];
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];
      if (!listener) {
        break;
      }
      if (target.tagName && ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 && target.hasAttribute("disabled")) {
        toFire = [];
      } else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }
    if (target === root) {
      break;
    }
    l = listenerList.length;
    target = target.parentElement || target.parentNode;
    if (target instanceof HTMLDocument) {
      break;
    }
  }
  let ret;
  for (i = 0; i < toFire.length; i++) {
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }
  return ret;
};
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return element === document || element === document.documentElement || element === window;
  }
  return this.rootElement === element;
}
function matchesId(id, element) {
  return id === element.id;
}
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};
var main_default = Delegate;

// js/custom-element/custom-html-element.js
var CustomHTMLElement = class extends HTMLElement {
  constructor() {
    super();
  }
  get rootDelegate() {
    return this._rootDelegate = this._rootDelegate || new main_default(document.documentElement);
  }
  get delegate() {
    return this._delegate = this._delegate || new main_default(this);
  }
  disconnectedCallback() {
    this.delegate.destroy();
    this.rootDelegate.destroy();
    delete this._delegate;
    delete this._rootDelegate;
  }
};

function triggerEvent(element, name, data = {}) {
  element.dispatchEvent(new CustomEvent(name, {
    bubbles: true,
    detail: data
  }));
}

// js/custom-element/section/product-facet/product-facet.js
var ProductFacet = class extends CustomHTMLElement {
  connectedCallback() {
    this.delegate.on("pagination:page-changed", this._rerender.bind(this));
    this.delegate.on("facet:criteria-changed", this._rerender.bind(this));
    this.delegate.on("facet:abort-loading", this._abort.bind(this));
  }
  showLoadingBar() {
    // console.log('showLoadingBar')
  }
  hideLoadingBar() {
    // console.log('hideLoadingBar')
  }
  async _rerender(event) {
    history.replaceState({}, "", event.detail.url);
    this._abort();
    this.showLoadingBar();
    const url = new URL(window.location);
    url.searchParams.set("section_id", this.getAttribute("section-id"));
    try {
      this.abortController = new AbortController();
      const response = await fetch(url.toString(), { signal: this.abortController.signal });
      const responseAsText = await response.text();
      const fakeDiv = document.createElement("div");
      fakeDiv.innerHTML = responseAsText;
      document.querySelectorAll(".collection-title").forEach(function(title) {
        title.innerHTML = fakeDiv.querySelectorAll(".collection-title")[0].innerHTML;
      });
      this.querySelector("#facet-main").innerHTML = fakeDiv.querySelector("#facet-main").innerHTML;
      this.reinitKlaviyoBIS();
      
      const filtersTempDiv = fakeDiv.querySelector("#facet-filters");
      if (filtersTempDiv) {
        // const previousScrollTop = this.querySelector("#facet-filters-form").scrollTop;
        this.querySelector("#facet-filters").innerHTML = filtersTempDiv.innerHTML;
        // this.querySelector("#facet-filters-form").scrollTop = previousScrollTop;
      }
      // const scrollTo = this.querySelector(".product-facet__main");
      // requestAnimationFrame(() => {
      //   scrollTo.scrollIntoView({ block: "start", behavior: "smooth" });
      // });

      Array.from(this.querySelector("#facet-main").querySelectorAll("form[action=\"/cart/add\"]")).forEach(form => form.addEventListener("submit", this.addToCart.bind(this)))

      if (!!window?.lazyLoadInstance) {
        lazyLoadInstance.update();
      }

      this.hideLoadingBar();
    } catch (e) {
      if (e.name === "AbortError") {
        return;
      }
    }
  }

  reinitKlaviyoBIS() {
    const facetMain = this.querySelector('#facet-main');
    if (!facetMain) return;

    const newProductContainers = facetMain.querySelectorAll('.klaviyo-product-container');
    if (newProductContainers.length === 0) return;

    const masterTrigger = document.createElement('a');
    masterTrigger.className = 'add-to-cart button cta klaviyo-bis-trigger';
    masterTrigger.href = '#';
    masterTrigger.style.padding = 'inherit';
    masterTrigger.style.textAlign = 'center';
    masterTrigger.textContent = 'Notify Me When Available';

    newProductContainers.forEach(prodContainer => {
        const buttonContainer = prodContainer.querySelector('.klaviyo-button-container');
        const handle = prodContainer.dataset.klaviyoHandle;

        if (buttonContainer && !buttonContainer.querySelector('.klaviyo-bis-trigger')) {
            const newTrigger = masterTrigger.cloneNode(true);
            newTrigger.dataset.klaviyoHandle = handle;

            buttonContainer.appendChild(newTrigger);

            prodContainer.style.overflow = 'visible !important';
            prodContainer.style.position = 'initial !important';

            buttonContainer.style.setProperty('position', 'absolute', 'important');
            buttonContainer.style.display = 'inline-block';
            buttonContainer.style.top = '50%';
            buttonContainer.style.left = '50%';
            buttonContainer.style.opacity = '0';
            buttonContainer.style.textAlign = 'center';
            buttonContainer.style.width = '100%';
            const width = 100;
            buttonContainer.style.marginLeft = '-' + Math.round(width / 2) + 'px';

            const parentSection = prodContainer.closest('.bottom-section-product');
            if (parentSection) {
              parentSection.style.setProperty('position', 'relative');
            }

            const parentCard = prodContainer.parentElement;
            if (parentCard) {
                parentCard.addEventListener('mouseover', function() {
                    const btnContainer = this.querySelector('.klaviyo-button-container');
                    if (btnContainer) btnContainer.style.opacity = '1';
                });
                parentCard.addEventListener('mouseout', function() {
                    const btnContainer = this.querySelector('.klaviyo-button-container');
                    if (btnContainer) btnContainer.style.opacity = '0';
                });
            }
        }
    });

    console.log(`Klaviyo BIS: Processed ${newProductContainers.length} new containers.`);
  }
  
  addToCart(event) {
    event.preventDefault();
    
    window.fetch("/cart/add.js", {
      method: "POST",
      body: new FormData(event.target)
    })
    .then(response => response.json())
    .then(json => {
      window.ddSmartCart?.open()
    });
  }
  _abort() {
    if (this.abortController) {
      this.abortController.abort();
    }
  }
};
window.customElements.define("product-facet", ProductFacet);

// js/custom-element/section/facet/facet-filters.js
var FacetFilters = class extends CustomHTMLElement {
  connectedCallback() {
    this.delegate.on("click", '[name^="filter."]', this._onFilterClicked.bind(this));
    this.delegate.on("change", '[name^="filter."]', this._onFilterChanged.bind(this));
    this.delegate.on("change", '[name^="mobile.filter."]', this._onFilterChangedMobile.bind(this));
    this.delegate.on("click", '.product-facet__filter-list--desktop .filter-section .filter-header', this._onFilterToggle.bind(this));
    this.rootDelegate.on("click", '[data-action="clear-filters"]', this._onFiltersCleared.bind(this));
  }
  _onFiltersCleared(event, target) {
    event.preventDefault();
    triggerEvent(this, "facet:criteria-changed", { url: target.href });
  }
  _onFilterClicked(event) {
    const filterEl = event.target;
    const searchParams = new URLSearchParams(window.location.href);
    if (filterEl.checked && searchParams.get(filterEl.name) === filterEl.value) {
      filterEl.checked = false;
      this._onFilterChanged(event);
    }
  }
  _onFilterChanged(event) {
    const formData = new FormData(this.querySelector("#facet-filters-form"));
    const searchParams = new URLSearchParams(formData);
    triggerEvent(this, "facet:criteria-changed", { url: `${window.location.pathname}?${searchParams.toString()}` });
  }
  _onFilterChangedMobile(event) {
    let filter = event.target;
    document.querySelector(`input[name="${filter.name.replace("mobile.", "")}"][value="${filter.value}"]`).click();
  }
  _onFilterToggle(event) {
    event.preventDefault();
    event.target.toggleAttribute("data-active");
  }
};
window.customElements.define("facet-filters", FacetFilters);

var VehicleSearch = class extends CustomHTMLElement {
  connectedCallback() {
    this.delegate.on("search:criteria-changed", this._rerender.bind(this));
    this.delegate.on("change", "[name^=\"filter.\"]", this._onFilterChanged.bind(this));
    this.delegate.on("click", "a[href=\"#reset\"]", this._onFiltersReset.bind(this));
    this.delegate.on("submit", "form", this._onSubmit.bind(this));

    // set form HTML (temporary until _rerender is completed)
    if (this.form?.innerHTML && !!window.sessionStorage.getItem(`${this.localStorageKey}-form`)) {
      this.form.innerHTML = window.sessionStorage.getItem(`${this.localStorageKey}-form`);
    }
    
    let url;
    if (window.location.href.includes(this.searchUrl)) {
      url = window.location.href;
    } else if (!!window.localStorage.getItem(this.localStorageKey)) {
      let keys = ["year", "make", "engine"];
      let searchParams = window.localStorage.getItem(this.localStorageKey)?.split(",")?.map((value, i) => `${this.filterParamPrefix}.${keys[i]}=${value}`);
      url = `${this.searchUrl}?${searchParams?.join("&")}`;
    }
    triggerEvent(this, "search:criteria-changed", { url });
  }
  get filterParamPrefix() {
    return "filter.p.m.search";
  }
  get localStorageKey() {
    return "vehicle-selected";
  }
  get searchUrl() {
    return `${window.location.origin}/collections/vehicle-selection`;
  }
  get isMobile() {
    return window.matchMedia("(max-width: 991px)").matches;
  }
  get form() {
    return this.querySelector("form");
  }
  async _rerender(event) {
    this._abort();
    
    const url = new URL(event.detail?.url || this.searchUrl);
    url.searchParams.set("view", "vehicle-search");
    let searchUrl = url.toString();
    
    // Include specific product types to populate search form
    ["Cabin Air Filter", "CCV Filter", "Combo Kit", "Engine Air Filter", "Filter Kit", "Filter Set", "Fuel Filter", "Fuel/Water Separator", "Maintenance Kit", "Oil Filter", "Transmission Filter Kit", "Transmission Service Kit"].forEach(function(type) {
      searchUrl += `&filter.p.product_type=${encodeURIComponent(type)}`
    });
    
    try {
      this.abortController = new AbortController();
      const response = await fetch(searchUrl, { signal: this.abortController.signal });
      const responseAsText = await response.text();
      const fakeDiv = document.createElement("div");
      fakeDiv.innerHTML = responseAsText;
      // A throttled, redirected or error response has no form in it. When that
      // happens the placeholder selects stay disabled forever, which is what
      // produces the dead clicks on this widget - so make the failure visible
      // instead of discarding it silently.
      const fetchedForm = fakeDiv.querySelector("form");
      if (!fetchedForm) {
        console.warn("vehicle-search: hydration response contained no form", response.status, searchUrl);
      } else if (this.form?.innerHTML) {
        this.form.innerHTML = fetchedForm.innerHTML;
      }
    } catch (e) {
      if (e.name === "AbortError") {
        return;
      }
      console.warn("vehicle-search: hydration failed", e);
    } finally {
      if (this.form?.innerHTML) window.sessionStorage.setItem(`${this.localStorageKey}-form`, this.form.innerHTML);
    }
  }
  _onFilterChanged(event) {
    const filterName = event.target.name;
    const searchParams = new URLSearchParams(new FormData(this.form));

    if (filterName.includes("year")) {
      searchParams.delete(`${this.filterParamPrefix}.make`);
      searchParams.delete(`${this.filterParamPrefix}.engine`);
    } else if (filterName.includes("make")) {
      searchParams.delete(`${this.filterParamPrefix}.engine`);
    }

    if (!!searchParams.get(`${this.filterParamPrefix}.year`)
      && !!searchParams.get(`${this.filterParamPrefix}.make`)
      && !!searchParams.get(`${this.filterParamPrefix}.engine`)) {
      // auto-submit on desktop
      if (this.parentElement.classList.contains("header-search")) triggerEvent(this.form, "submit");
    } else {
      triggerEvent(this, "search:criteria-changed", { url: `${this.searchUrl}?${searchParams.toString()}` });
    }
  }
  _onFiltersReset(event) {
    event.preventDefault();
    this.form.reset();

    window.localStorage.removeItem(this.localStorageKey);
    window.sessionStorage.removeItem(`${this.localStorageKey}-form`);

    triggerEvent(this, "search:criteria-changed");
  }
  _onSubmit(event) {
    event.preventDefault();
    const searchParams = new URLSearchParams(new FormData(this.form));
    
    window.localStorage.setItem(this.localStorageKey, [
      searchParams.get(`${this.filterParamPrefix}.year`),
      searchParams.get(`${this.filterParamPrefix}.make`),
      searchParams.get(`${this.filterParamPrefix}.engine`)
    ].join(","));
    window.sessionStorage.setItem(`${this.localStorageKey}-form`, this.form.innerHTML);

    // trigger Shopify event
    Shopify?.analytics?.publish('vehicle_search', {
      year: searchParams.get(`${this.filterParamPrefix}.year`),
      make: searchParams.get(`${this.filterParamPrefix}.make`),
      engine: searchParams.get(`${this.filterParamPrefix}.engine`)
    });
    
    window.location = `${this.searchUrl}?${searchParams.toString()}`;
  }
  _abort() {
    if (this.abortController) {
      this.abortController.abort();
    }
  }
}
window.customElements.define("vehicle-search", VehicleSearch);